module.exports = __webpack_public_path__ + "img/DE00711.0048f519.png";